import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Nav } from "react-bootstrap";
import "./Nav.css";
import NavBarLogoFinal from "../../media/NavBarLogoFinal.svg";
import { useAuth } from "../../auth";
import {
  checkForReferenceServicesCandidate,
  getCandidateByEmail,
} from "../../services/candidateService";

interface CandidateNavProps {
  isMobile: boolean;
  isSidebarOpen: boolean;
  toggleSidebar: () => void;
  handleLogout: () => void;
}

const CandidateNav: React.FC<CandidateNavProps> = ({
  isMobile,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
}) => {
  const [showReferencePage, setShowReferencePage] = useState(false);
  const { decodeToken } = useAuth();

  useEffect(() => {
    const fetchFormStatus = async () => {
      try {
        const email = decodeToken(localStorage.getItem("token") || "");
        const candidate = await getCandidateByEmail(email);

        const isReferencePageAllowed = await checkForReferenceServicesCandidate(
          candidate.candidateID,
        );
        setShowReferencePage(isReferencePageAllowed);
      } catch (error) {
        console.error("Error checking form status:", error);
        setShowReferencePage(false);
      }
    };

    fetchFormStatus();
  }, [decodeToken]);

  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : "closed"}`}>
      {isMobile && (
        <div className="mobile-header">
          <div className="hamburger-button" onClick={toggleSidebar}>
            &#9776;
          </div>
          {isSidebarOpen && (
            <img
              src={NavBarLogoFinal}
              alt="Oxford Logo"
              className="sidebar-logo"
              // onClick={() =>
              //   window.open("https://www.oxforddoc.com/", "_blank")
              // }
            />
          )}
        </div>
      )}

      {isSidebarOpen && (
        <>
          {!isMobile && (
            <div className="sidebar-header">
              <img
                src={NavBarLogoFinal}
                alt="Oxford Logo"
                className="sidebar-logo"
                // onClick={() =>
                //   window.open("https://www.oxforddoc.com/", "_blank")
                // }
              />
            </div>
          )}
          <Nav className="flex-column">
            <Nav.Item>
              <Nav.Link as={Link} to="/candidate/needs-review">
                <i className="bi bi-people-fill nav-icon" />
                Needs Review
              </Nav.Link>
            </Nav.Item>
            {showReferencePage && (
              <Nav.Item>
                <Nav.Link as={Link} to="/candidate/reference-statuses">
                  <i className="bi bi-hourglass-split" /> Reference Status
                </Nav.Link>
              </Nav.Item>
            )}
            {/* 
            <Nav.Item>
              <Nav.Link as={Link} to="/candidate/past-references">
                <i className=" bi bi-pen-fill nav-icon" />
                Past References
              </Nav.Link>
            </Nav.Item> */}

            {/* <Nav.Item>
              <Nav.Link as={Link} to="/candidate/past-background-checks">
                <i className="bi bi-clipboard-fill nav-icon" />
                Past Background Checks
              </Nav.Link>
            </Nav.Item> */}

            <Nav.Item>
              <Button
                onClick={handleLogout}
                variant="outline-light"
                className="signout-button"
              >
                Sign Out <i className="bi bi-box-arrow-right sign-out-icon"></i>
              </Button>
            </Nav.Item>

            <Nav.Item className="mt-auto">
              <Button
                onClick={() =>
                  window.open("/help", "_blank", "noopener,noreferrer")
                }
                variant="outline-light"
                className="signout-button"
              >
                Contact Us/Need Help{" "}
                <i className="bi bi-question-circle btn-icon"></i>
              </Button>

              <div className="btn-contact">
                <a href="/privacy-policy" className="btn-contact-field">
                  Privacy Policy
                </a>
              </div>
            </Nav.Item>
          </Nav>
        </>
      )}
    </div>
  );
};

export default CandidateNav;
